import InnerComponent from '@Components/Purchase/OutgoingPayments/CreateOutgoingPayment';
import orgContainer from '@Components/AppContainer';

const CreateOutgoingPayment = () => ((orgContainer(InnerComponent)));
export default CreateOutgoingPayment;
